import makeLevel from '../makeLevel.js';
import * as powerups from '../../powerups.js';

export default makeLevel([
  "                    ",
  "       r            ",
  "       rr           ",
  "       r!r          ",
  " b     r!rr         ",
  " bb    rrrrr        ",
  " b0b   r!r!r        ",
  " b0bb  r!r!r      y ",
  " bbbbb rrrrr     yy ",
  " b0b0b r!r!r    y0y ",
  " b0b0b r!r!r   yy0y ",
  " bbbbb rrrrr  yyyyy ",
  " b0b0b r!r!r  y0y0y ",
  " b0b0b r!r!r  y0y0y ",
  " bbbbb rrrrr  yyyyy ",
  " b0b0b r!r!r  y0y1y ",
  " b0b0b r!r!r  y0y1y ",
  " bbbbb rrrrr  yyyyy ",
  "********************",
  "********************",
], [
    {
        "5": powerups.ballExtra,
        "8": powerups.ballSpeedDown,
        "9": powerups.ballSpeedDown,
        "16": powerups.lightning,
        "20": powerups.extraLive,
        "21": powerups.paddleGrow,
        "24": powerups.paddleShrink,
        "27": powerups.paddleShrink,
        "39": powerups.ballUnstopable,
        "41": powerups.paddleLasers,
        "46": powerups.paddleShrink,
        "63": powerups.ballSpeedDown,
        "67": powerups.ballSpeedDown,
        "72": powerups.paddleSticky,
        "73": powerups.weakenBlocks,
        "89": powerups.ballExploding,
        "97": powerups.paddleShrink,
        "102": powerups.paddleGrow,
        "107": powerups.paddleSticky,
        "108": powerups.paddleSticky,
        "114": powerups.ballSpeedUp,
        "117": powerups.paddleSticky,
        "124": powerups.paddleGrow,
        "131": powerups.ballSpeedUp,
        "132": powerups.lightning,
        "136": powerups.ballSpeedUp,
        "147": powerups.instaDeath,
        "156": powerups.paddleLasers,
        "164": powerups.weakenBlocks,
        "167": powerups.ballUnstopable,
        "179": powerups.ballSpeedUp,
        "181": powerups.ballSpeedUp,
        "182": powerups.ballExploding,
        "185": powerups.paddleGrow,
        "188": powerups.ballExtra,
        "205": powerups.ballExtra,
        "212": powerups.paddleShrink,
        "218": powerups.instaDeath
    },
    {
        "3": powerups.paddleSticky,
        "7": powerups.ballExtra,
        "8": powerups.paddleGrow,
        "15": powerups.ballUnstopable,
        "18": powerups.paddleShrink,
        "19": powerups.ballSpeedDown,
        "22": powerups.ballUnstopable,
        "25": powerups.ballUnstopable,
        "30": powerups.ballExtra,
        "33": powerups.extraLive,
        "37": powerups.ballExtra,
        "43": powerups.ballExtra,
        "48": powerups.paddleShrink,
        "53": powerups.ballExtra,
        "59": powerups.ballSpeedDown,
        "62": powerups.ballExploding,
        "66": powerups.paddleSticky,
        "76": powerups.ballExtra,
        "84": powerups.paddleGrow,
        "89": powerups.ballExtra,
        "90": powerups.paddleLasers,
        "94": powerups.ballExploding,
        "100": powerups.paddleSticky,
        "105": powerups.paddleGrow,
        "106": powerups.ballSpeedUp,
        "112": powerups.ballSpeedDown,
        "116": powerups.ballSpeedDown,
        "126": powerups.skipLevel,
        "130": powerups.paddleGrow,
        "131": powerups.ballExtra,
        "140": powerups.ballExtra,
        "150": powerups.ballExploding,
        "152": powerups.paddleShrink,
        "162": powerups.paddleLasers,
        "164": powerups.paddleGrow,
        "165": powerups.paddleShrink,
        "167": powerups.ballExtra,
        "171": powerups.paddleShrink,
        "172": powerups.ballSpeedUp,
        "178": powerups.paddleMini,
        "182": powerups.paddleGrow,
        "183": powerups.ballUnstopable,
        "186": powerups.lightning,
        "189": powerups.ballUnstopable,
        "191": powerups.paddleLasers,
        "194": powerups.paddleGrow,
        "207": powerups.extraLive
    },
    {
        "6": powerups.skipLevel,
        "8": powerups.lightning,
        "9": powerups.ballExploding,
        "11": powerups.ballSpeedUp,
        "25": powerups.instaDeath,
        "42": powerups.paddleLasers,
        "44": powerups.paddleMini,
        "47": powerups.paddleShrink,
        "48": powerups.ballExtra,
        "49": powerups.paddleShrink,
        "51": powerups.skipLevel,
        "58": powerups.paddleMini,
        "64": powerups.skipLevel,
        "65": powerups.paddleSticky,
        "70": powerups.ballSpeedDown,
        "76": powerups.ballExploding,
        "78": powerups.paddleShrink,
        "93": powerups.weakenBlocks,
        "101": powerups.ballSpeedDown,
        "105": powerups.ballSpeedDown,
        "107": powerups.paddleGrow,
        "114": powerups.ballSpeedDown,
        "115": powerups.weakenBlocks,
        "117": powerups.ballSpeedUp,
        "118": powerups.ballSpeedDown,
        "119": powerups.paddleSticky,
        "125": powerups.ballSpeedUp,
        "130": powerups.paddleLasers,
        "144": powerups.ballSpeedDown,
        "145": powerups.ballSpeedUp,
        "151": powerups.paddleShrink,
        "152": powerups.paddleShrink,
        "156": powerups.ballSpeedUp,
        "159": powerups.ballExtra,
        "161": powerups.paddleGrow,
        "166": powerups.ballExtra,
        "172": powerups.paddleSticky,
        "181": powerups.weakenBlocks,
        "184": powerups.paddleShrink,
        "187": powerups.paddleShrink,
        "192": powerups.skipLevel,
        "193": powerups.paddleGrow,
        "194": powerups.paddleGrow,
        "216": powerups.lightning
    },
    {
        "2": powerups.paddleLasers,
        "6": powerups.ballUnstopable,
        "8": powerups.ballExtra,
        "9": powerups.paddleShrink,
        "11": powerups.ballExploding,
        "16": powerups.ballSpeedUp,
        "20": powerups.paddleMini,
        "26": powerups.ballExploding,
        "27": powerups.ballSpeedUp,
        "30": powerups.extraLive,
        "38": powerups.paddleShrink,
        "47": powerups.instaDeath,
        "50": powerups.ballUnstopable,
        "51": powerups.instaDeath,
        "54": powerups.lightning,
        "60": powerups.ballSpeedDown,
        "66": powerups.paddleShrink,
        "70": powerups.ballSpeedDown,
        "81": powerups.extraLive,
        "84": powerups.paddleGrow,
        "85": powerups.ballSpeedDown,
        "90": powerups.ballSpeedDown,
        "92": powerups.paddleSticky,
        "100": powerups.paddleLasers,
        "106": powerups.ballSpeedUp,
        "109": powerups.paddleGrow,
        "111": powerups.paddleShrink,
        "112": powerups.ballExtra,
        "117": powerups.paddleGrow,
        "119": powerups.ballSpeedUp,
        "120": powerups.ballSpeedUp,
        "123": powerups.ballExploding,
        "126": powerups.ballSpeedDown,
        "128": powerups.skipLevel,
        "134": powerups.paddleShrink,
        "135": powerups.paddleShrink,
        "140": powerups.paddleGrow,
        "151": powerups.ballSpeedUp,
        "155": powerups.ballSpeedUp,
        "157": powerups.ballExtra,
        "160": powerups.skipLevel,
        "173": powerups.lightning,
        "179": powerups.ballExploding,
        "180": powerups.paddleShrink,
        "187": powerups.ballExtra,
        "188": powerups.lightning,
        "190": powerups.ballExtra,
        "196": powerups.lightning,
        "197": powerups.ballSpeedUp,
        "198": powerups.paddleGrow,
        "210": powerups.ballSpeedUp,
        "212": powerups.paddleSticky
    }
]);
